var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "col-12 header", class: { searching: _vm.isSearching } },
      [
        _c("i", {
          staticClass: "fa fa-bars pull-left",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v(" "),
        _c("label", [_vm._v(" " + _vm._s(_vm.title) + " ")]),
        _vm._v(" "),
        _vm.canSearch
          ? _c("i", {
              staticClass: "fa fa-search pull-right action-item",
              attrs: { "aria-hidden": "true" },
              on: {
                click: function($event) {
                  _vm.isSearching = !_vm.isSearching
                }
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm._t("template-listing-header"),
        _vm._v(" "),
        _vm.isSearching
          ? _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchValue,
                  expression: "searchValue"
                }
              ],
              staticClass: "form-control",
              attrs: {
                placeholder: _vm.resource(
                  "TemplateListingBase_SearchValue_PlaceHolder"
                ),
                type: "text"
              },
              domProps: { value: _vm.searchValue },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.searchValue = $event.target.value
                }
              }
            })
          : _vm._e()
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("label", [_vm._v(" " + _vm._s(_vm.listTitle) + " ")])
          ])
        ]),
        _vm._v(" "),
        _vm._l(_vm.displayedTemplates, function(template) {
          return _c(
            "div",
            {
              key: template.Id,
              staticClass: "row template-listing",
              class: { selected: _vm.selectedTemplate === template },
              on: {
                click: function($event) {
                  return _vm.templateSelected(template)
                }
              }
            },
            [_vm._t("template-listing-item", null, { template: template })],
            2
          )
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }